import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// @dynamic
@Component({
  selector: 'sc-google-maps-dialog',
  templateUrl: './sc-google-maps-dialog.component.html',
  styleUrls: ['./sc-google-maps-dialog.component.scss']
})
export class ScGoogleMapsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ScGoogleMapsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { long: number; lat: number; title: string }
  ) {}

  ngOnInit() {}
}
